module.exports = __webpack_public_path__ + "static/img/submint.c471d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/submint.png
// module id = BTdh
// module chunks = 208